import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import "./WishListChatCard.css";
import {
  applyUniversity,
  deleteApplication,
  deleteWishlist,
  getAllUserApplications,
  getAllUserApplicationsBasedOnStatus,
  getAllWishlistUniversities,
  updateApplication,
} from "../../../HttpRequest/applyapplication";
import Pagination from "../../Base UI/Pagination";
import {
  WarningAlert,
  applicationWithDraw,
  cancelButton,
} from "../../Base UI Elements/SweetAlert";
import ModelUpload from "../../../ModelUpload";

export default function WishListChatCard(passingUserId) {
  const [userIdWishlist, setuserIdWishlist] = useState([]);
  const [data, setData] = useState([]);
  const [application, setApplication] = useState();
  const [popup, setPopup] = useState(false);
  const [pagedata, setpagedata] = useState();
  const [checkedIndex, setCheckedIndex] = useState(1);
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 20,
  });
  const deleteWishlistFunction = async (id) => {
    cancelButton(async (userClickedYes) => {
      if (userClickedYes) {
        try {
          console.log("delete is calling-->", id);
          const response = await deleteWishlist(id);
          console.log("delete is done...!", response);
          if (response.status === 204) {
            console.log("delete is successful!");
            fetchData();
          } else {
            console.log("data error");
          }
        } catch (error) {
          console.error("Error during delete:", error);
        }
      } else {
        console.log("User clicked No or dismissed the dialog");
      }
    });
  };
  const fetchData = async () => {
    let userId ="";
    try {
      if(localStorage.getItem("userRole") === "admin"){
        const id = passingUserId.location.state;
        userId = id.passingUserId;
        console.log("userId in the wishlist==>",userId);
      }else{
        userId = localStorage.getItem("id");
      }
      const response = getAllWishlistUniversities(
        userId,
        pageInfo.page,
        pageInfo.size
      );
      response.then((data) => {
        console.log("User applied applications===>", data);
        if (data.request.status == 200) {
          setpagedata(data.metaData);
          setData(data.data);
          setCheckedIndex(1);
        } else {
          console.log("data error");
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [passingUserId,pageInfo]);

  const setPopUpClose = (data) => {
    console.log("pop up close is calling-->",data)
    setPopup(data);
  };

  const setPageInfoData = (data) => {
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };
  const applyUniversityInWishlist = (masterDataEntityId, userId) => {
    try {
      let application = {
        userId: userId,
        status: "application-requested",
        masterDataEntityId: masterDataEntityId,
      };
      applyUniversity(application).then((response) => {
        if (response.status = 201) {
          console.log("response of apply in wishlist==>", response);
          setApplication(response.data);
          setPopup(true);
        } else {
          WarningAlert(
            "Unable to apply. Please contact the support team.",
            "/admindashboard"
          );
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">My Wishlist </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">My Wishlist</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                <div className="row col-12">
                  <div className="chatgrop" >
                    {data.data?.map((item) => (
                      <div className="chatcards" key={item.applicationId}>
                        <div className="apliactionid">
                          Wishlist Id: {item.wishListId}
                        </div>
                        <div className="cardunivercityname"> 
                          <p>
                            <i class="fa-solid fa-school fw-bold"></i>{" "}
                            <strong>{item.name}</strong>
                          </p>
                          <p>
                            <i class="fa-solid fa-graduation-cap fw-bold"></i>{" "}
                            {item.university}
                          </p>
                        </div>
                        <div className="boxcontainer1">
                          <div
                            type="button"
                            className="h5  m-0"
                            onClick={() => deleteWishlistFunction(item.id)}
                          >
                            <i class="fa-solid fa-trash text-danger"></i>
                          </div>
                          <h6
                            className="programapplybtn"
                            onClick={() =>
                              applyUniversityInWishlist(
                                item.masterDataEntityId,
                                item.userId
                              )
                            }
                          >
                            Apply
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {pagedata && (
            <Pagination
              pageResponce={pagedata}
              pagedataToParent={setPageInfoData}
            />
          )}
          {popup && (
            <ModelUpload
              applicationobj={application}
              closePopup={setPopUpClose}
            />
          )}
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
